import default_ from '../../lib/jin/svgchartlib/01_Charts/06_Histogram/includes/primitives/Data'

export default default_